export const FEATURE_FLAGS = {
  speakingPractice: false,
  /**
   * WebRTC video call feature.
   * Set NEXT_PUBLIC_WEBRTC_ENABLED=true in environment to enable.
   * Defaults to disabled for production safety.
   */
  webrtcVideoCall: process.env.NEXT_PUBLIC_WEBRTC_ENABLED === 'true',
  /**
   * Google OAuth sign-in/sign-up.
   * Enabled when NEXT_PUBLIC_GOOGLE_CLIENT_ID is set.
   */
  googleOAuth: !!process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID,
};
